import request from "@/utils/axios";
import { param } from "jquery";

//  获取邮件模板
export function TEMPLATES(data) {
    return request({
        url: '/api/email/templates',
        method: 'get',
        data
    })
}

export function EMAILTEMPLATE(data) {
    return request({
        url: '/api/email/getEmailTemplatesPage',
        method: 'POST',
        data
    })
}

export function ADDEMAILTEMPLATE(data) {
    return request({
        url: '/api/email/addTemplates',
        method: 'POST',
        data
    })
}
export function UPDATEEMAILTEMPLATE(data) {
    return request({
        url: '/api/email/updateTemplatesById',
        method: 'POST',
        data
    })
}//

export function DELETEEMAILTEMPLATE(param) {
    return request({
        url: '/api/email/deleteTemplatesById?id=' + param.id,
        method: 'get',
    })
}

//  发邮件
export function SENDEMAIL(data) {
    return request({
        url: '/api/email/sendEmail',
        method: 'post',
        data
    })
}
//  发件箱列表
export function QUERYEMAILSENDLIST(data) {
    return request({
        url: '/api/email/queryEmailSendList',
        method: 'post',
        data
    })
}
//  发件箱星标（取消或打标）
export function EMAILSENDSTARMARK(data) {
    return request({
        url: '/api/email/emailSendStarMark',
        method: 'post',
        data
    })
}
//  根据ID删除发件箱
export function DELSENDEMAIL(data) {
    return request({
        url: '/api/email/delSendEmail',
        method: 'post',
        data
    })
}
//  收件箱列表
export function QUERYEMAILRECEIVELIST(data) {
    return request({
        url: '/api/email/queryEmailReceiveList',
        method: 'post',
        data
    })
}
//  根据ID删除收件箱
export function DELRECEIVEEMAIL(data) {
    return request({
        url: '/api/email/delReceiveEmail',
        method: 'post',
        data
    })
}
//  收件箱星标（取消或打标）
export function EMAILRECEIVESTARMARK(data) {
    return request({
        url: '/api/email/emailReceiveStarMark',
        method: 'post',
        data
    })
}
//  根据ID查询收件箱信息
export function QUERYEMAILRECEIVE(data) {
    return request({
        url: '/api/email/queryEmailReceive',
        method: 'post',
        data
    })
}
//  根据ID查询发件箱信息
export function QUERYEMAILSEND(data) {
    return request({
        url: '/api/email/queryEmailSend',
        method: 'post',
        data
    })
}
//  回复邮件
export function REPLYEMAIL(data) {
    return request({
        url: '/api/email/replyEmail',
        method: 'post',
        data
    })
}
//  根据ID标记收件箱已读
export function ONEREAD(data) {
    return request({
        url: '/api/email/oneRead',
        method: 'post',
        data
    })
}
//  标记收件箱全部已读
export function ALLREAD(data) {
    return request({
        url: '/api/email/allRead',
        method: 'get',
        data
    })
}




//  星标邮件列表（分页）
export function QUERYEMAILSTARMARKLIST(data) {
    return request({
        url: '/api/email/queryEmailStarMarkList',
        method: 'post',
        data
    })
}
//  星标邮件（星标取消或删除）
export function EMAILSTARMARKDEAL(data) {
    return request({
        url: '/api/email/emailStarMarkDeal',
        method: 'post',
        data
    })
}


//  邮件中心-折线图
export function QUERYEMAILDATA(data) {
    return request({
        url: '/api/email/queryEmailData',
        method: 'post',
        data
    })
}
//  邮件中心-最近联系人
export function QUERYRECENTLYPERSON(data) {
    return request({
        url: '/api/email/queryRecentlyPerson',
        method: 'get',
        data
    })
}
//  邮件中心-联盟客地域分布
export function QUERYALLIANCEAREA(data) {
    return request({
        url: '/api/email/queryAllianceArea',
        method: 'get',
        data
    })
}
//  邮件中心-未读邮件星标邮件（数量）
export function QUERYNOREADSTARMARK(data) {
    return request({
        url: '/api/email/queryNoReadStarMark',
        method: 'get',
        data
    })
}

//  我的关注，发件箱，收件箱，打开率，回复率，合作联盟客(数值）
export function QUERYTOTALCOUNT(data) {
    return request({
        url: '/api/email/queryTotalCount',
        method: 'get',
        data
    })
}
//  获取登录信息
export function QUERY(data) {
    return request({
        url: '/api/users/query',
        method: 'get',
        data
    })
}

export function QUERYMAINPERMIT(data) {
    return request({
        url: '/api/users/queryMainPermit',
        method: 'get',
        data
    })
}

export function QUERYEMAILSENDANDTOTLENUM(data) {
    return request({
        url: '/api/email/queryEmailSendAndTotleNum',
        method: 'get',
        data
    })
}

// 确认是否可以建联
export function CHECKBATCHSENDEMAIL(data) {
    return request({
        url: '/api/email/checkBatchSendEmail',
        method: 'post',
        data
    })
}
